var At = Object.defineProperty;
var _t = (o, t, e) => t in o ? At(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var E = (o, t, e) => (_t(o, typeof t != "symbol" ? t + "" : t, e), e);
import * as M from "react";
import Ke from "react";
import { cn as ge, Button as ee } from "@spiaggeit/spit-ui";
import { DateTime as j } from "luxon";
import { isSameDay as Nt, getCalendarsByPeriod as Ot } from "./dateUtils.js";
var pe = { exports: {} }, U = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Be;
function jt() {
  return Be || (Be = 1, process.env.NODE_ENV !== "production" && function() {
    var o = Ke, t = Symbol.for("react.element"), e = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), S = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), m = Symbol.iterator, D = "@@iterator";
    function A(r) {
      if (r === null || typeof r != "object")
        return null;
      var d = m && r[m] || r[D];
      return typeof d == "function" ? d : null;
    }
    var N = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function R(r) {
      {
        for (var d = arguments.length, u = new Array(d > 1 ? d - 1 : 0), h = 1; h < d; h++)
          u[h - 1] = arguments[h];
        I("error", r, u);
      }
    }
    function I(r, d, u) {
      {
        var h = N.ReactDebugCurrentFrame, x = h.getStackAddendum();
        x !== "" && (d += "%s", u = u.concat([x]));
        var C = u.map(function(y) {
          return String(y);
        });
        C.unshift("Warning: " + d), Function.prototype.apply.call(console[r], console, C);
      }
    }
    var et = !1, tt = !1, rt = !1, at = !1, nt = !1, be;
    be = Symbol.for("react.module.reference");
    function ot(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === a || r === i || nt || r === n || r === g || r === p || at || r === k || et || tt || rt || typeof r == "object" && r !== null && (r.$$typeof === f || r.$$typeof === S || r.$$typeof === s || r.$$typeof === c || r.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === be || r.getModuleId !== void 0));
    }
    function it(r, d, u) {
      var h = r.displayName;
      if (h)
        return h;
      var x = d.displayName || d.name || "";
      return x !== "" ? u + "(" + x + ")" : u;
    }
    function me(r) {
      return r.displayName || "Context";
    }
    function Y(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && R("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case a:
          return "Fragment";
        case e:
          return "Portal";
        case i:
          return "Profiler";
        case n:
          return "StrictMode";
        case g:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case c:
            var d = r;
            return me(d) + ".Consumer";
          case s:
            var u = r;
            return me(u._context) + ".Provider";
          case l:
            return it(r, r.render, "ForwardRef");
          case S:
            var h = r.displayName || null;
            return h !== null ? h : Y(r.type) || "Memo";
          case f: {
            var x = r, C = x._payload, y = x._init;
            try {
              return Y(y(C));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, V = 0, ye, ve, xe, ke, we, De, Ce;
    function Ee() {
    }
    Ee.__reactDisabledLog = !0;
    function dt() {
      {
        if (V === 0) {
          ye = console.log, ve = console.info, xe = console.warn, ke = console.error, we = console.group, De = console.groupCollapsed, Ce = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        V++;
      }
    }
    function st() {
      {
        if (V--, V === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, r, {
              value: ye
            }),
            info: z({}, r, {
              value: ve
            }),
            warn: z({}, r, {
              value: xe
            }),
            error: z({}, r, {
              value: ke
            }),
            group: z({}, r, {
              value: we
            }),
            groupCollapsed: z({}, r, {
              value: De
            }),
            groupEnd: z({}, r, {
              value: Ce
            })
          });
        }
        V < 0 && R("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var re = N.ReactCurrentDispatcher, ae;
    function J(r, d, u) {
      {
        if (ae === void 0)
          try {
            throw Error();
          } catch (x) {
            var h = x.stack.trim().match(/\n( *(at )?)/);
            ae = h && h[1] || "";
          }
        return `
` + ae + r;
      }
    }
    var ne = !1, G;
    {
      var lt = typeof WeakMap == "function" ? WeakMap : Map;
      G = new lt();
    }
    function Se(r, d) {
      if (!r || ne)
        return "";
      {
        var u = G.get(r);
        if (u !== void 0)
          return u;
      }
      var h;
      ne = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var C;
      C = re.current, re.current = null, dt();
      try {
        if (d) {
          var y = function() {
            throw Error();
          };
          if (Object.defineProperty(y.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(y, []);
            } catch (F) {
              h = F;
            }
            Reflect.construct(r, [], y);
          } else {
            try {
              y.call();
            } catch (F) {
              h = F;
            }
            r.call(y.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            h = F;
          }
          r();
        }
      } catch (F) {
        if (F && h && typeof F.stack == "string") {
          for (var b = F.stack.split(`
`), _ = h.stack.split(`
`), L = b.length - 1, T = _.length - 1; L >= 1 && T >= 0 && b[L] !== _[T]; )
            T--;
          for (; L >= 1 && T >= 0; L--, T--)
            if (b[L] !== _[T]) {
              if (L !== 1 || T !== 1)
                do
                  if (L--, T--, T < 0 || b[L] !== _[T]) {
                    var O = `
` + b[L].replace(" at new ", " at ");
                    return r.displayName && O.includes("<anonymous>") && (O = O.replace("<anonymous>", r.displayName)), typeof r == "function" && G.set(r, O), O;
                  }
                while (L >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        ne = !1, re.current = C, st(), Error.prepareStackTrace = x;
      }
      var H = r ? r.displayName || r.name : "", Ie = H ? J(H) : "";
      return typeof r == "function" && G.set(r, Ie), Ie;
    }
    function ct(r, d, u) {
      return Se(r, !1);
    }
    function ut(r) {
      var d = r.prototype;
      return !!(d && d.isReactComponent);
    }
    function Z(r, d, u) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Se(r, ut(r));
      if (typeof r == "string")
        return J(r);
      switch (r) {
        case g:
          return J("Suspense");
        case p:
          return J("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            return ct(r.render);
          case S:
            return Z(r.type, d, u);
          case f: {
            var h = r, x = h._payload, C = h._init;
            try {
              return Z(C(x), d, u);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, Me = {}, Le = N.ReactDebugCurrentFrame;
    function X(r) {
      if (r) {
        var d = r._owner, u = Z(r.type, r._source, d ? d.type : null);
        Le.setExtraStackFrame(u);
      } else
        Le.setExtraStackFrame(null);
    }
    function gt(r, d, u, h, x) {
      {
        var C = Function.call.bind(K);
        for (var y in r)
          if (C(r, y)) {
            var b = void 0;
            try {
              if (typeof r[y] != "function") {
                var _ = Error((h || "React class") + ": " + u + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _.name = "Invariant Violation", _;
              }
              b = r[y](d, y, h, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              b = L;
            }
            b && !(b instanceof Error) && (X(x), R("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", u, y, typeof b), X(null)), b instanceof Error && !(b.message in Me) && (Me[b.message] = !0, X(x), R("Failed %s type: %s", u, b.message), X(null));
          }
      }
    }
    var pt = Array.isArray;
    function oe(r) {
      return pt(r);
    }
    function ht(r) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, u = d && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return u;
      }
    }
    function ft(r) {
      try {
        return Te(r), !1;
      } catch {
        return !0;
      }
    }
    function Te(r) {
      return "" + r;
    }
    function Pe(r) {
      if (ft(r))
        return R("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ht(r)), Te(r);
    }
    var W = N.ReactCurrentOwner, bt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Re, Ae, ie;
    ie = {};
    function mt(r) {
      if (K.call(r, "ref")) {
        var d = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function yt(r) {
      if (K.call(r, "key")) {
        var d = Object.getOwnPropertyDescriptor(r, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function vt(r, d) {
      if (typeof r.ref == "string" && W.current && d && W.current.stateNode !== d) {
        var u = Y(W.current.type);
        ie[u] || (R('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(W.current.type), r.ref), ie[u] = !0);
      }
    }
    function xt(r, d) {
      {
        var u = function() {
          Re || (Re = !0, R("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        u.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function kt(r, d) {
      {
        var u = function() {
          Ae || (Ae = !0, R("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        u.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var wt = function(r, d, u, h, x, C, y) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: r,
        key: d,
        ref: u,
        props: y,
        // Record the component responsible for creating this element.
        _owner: C
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function Dt(r, d, u, h, x) {
      {
        var C, y = {}, b = null, _ = null;
        u !== void 0 && (Pe(u), b = "" + u), yt(d) && (Pe(d.key), b = "" + d.key), mt(d) && (_ = d.ref, vt(d, x));
        for (C in d)
          K.call(d, C) && !bt.hasOwnProperty(C) && (y[C] = d[C]);
        if (r && r.defaultProps) {
          var L = r.defaultProps;
          for (C in L)
            y[C] === void 0 && (y[C] = L[C]);
        }
        if (b || _) {
          var T = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          b && xt(y, T), _ && kt(y, T);
        }
        return wt(r, b, _, x, h, W.current, y);
      }
    }
    var de = N.ReactCurrentOwner, _e = N.ReactDebugCurrentFrame;
    function $(r) {
      if (r) {
        var d = r._owner, u = Z(r.type, r._source, d ? d.type : null);
        _e.setExtraStackFrame(u);
      } else
        _e.setExtraStackFrame(null);
    }
    var se;
    se = !1;
    function le(r) {
      return typeof r == "object" && r !== null && r.$$typeof === t;
    }
    function Ne() {
      {
        if (de.current) {
          var r = Y(de.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Ct(r) {
      {
        if (r !== void 0) {
          var d = r.fileName.replace(/^.*[\\\/]/, ""), u = r.lineNumber;
          return `

Check your code at ` + d + ":" + u + ".";
        }
        return "";
      }
    }
    var Oe = {};
    function Et(r) {
      {
        var d = Ne();
        if (!d) {
          var u = typeof r == "string" ? r : r.displayName || r.name;
          u && (d = `

Check the top-level render call using <` + u + ">.");
        }
        return d;
      }
    }
    function je(r, d) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var u = Et(d);
        if (Oe[u])
          return;
        Oe[u] = !0;
        var h = "";
        r && r._owner && r._owner !== de.current && (h = " It was passed a child from " + Y(r._owner.type) + "."), $(r), R('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, h), $(null);
      }
    }
    function Ye(r, d) {
      {
        if (typeof r != "object")
          return;
        if (oe(r))
          for (var u = 0; u < r.length; u++) {
            var h = r[u];
            le(h) && je(h, d);
          }
        else if (le(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var x = A(r);
          if (typeof x == "function" && x !== r.entries)
            for (var C = x.call(r), y; !(y = C.next()).done; )
              le(y.value) && je(y.value, d);
        }
      }
    }
    function St(r) {
      {
        var d = r.type;
        if (d == null || typeof d == "string")
          return;
        var u;
        if (typeof d == "function")
          u = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === S))
          u = d.propTypes;
        else
          return;
        if (u) {
          var h = Y(d);
          gt(u, r.props, "prop", h, r);
        } else if (d.PropTypes !== void 0 && !se) {
          se = !0;
          var x = Y(d);
          R("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && R("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mt(r) {
      {
        for (var d = Object.keys(r.props), u = 0; u < d.length; u++) {
          var h = d[u];
          if (h !== "children" && h !== "key") {
            $(r), R("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), $(null);
            break;
          }
        }
        r.ref !== null && ($(r), R("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
      }
    }
    function Fe(r, d, u, h, x, C) {
      {
        var y = ot(r);
        if (!y) {
          var b = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _ = Ct(x);
          _ ? b += _ : b += Ne();
          var L;
          r === null ? L = "null" : oe(r) ? L = "array" : r !== void 0 && r.$$typeof === t ? (L = "<" + (Y(r.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : L = typeof r, R("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, b);
        }
        var T = Dt(r, d, u, x, C);
        if (T == null)
          return T;
        if (y) {
          var O = d.children;
          if (O !== void 0)
            if (h)
              if (oe(O)) {
                for (var H = 0; H < O.length; H++)
                  Ye(O[H], r);
                Object.freeze && Object.freeze(O);
              } else
                R("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ye(O, r);
        }
        return r === a ? Mt(T) : St(T), T;
      }
    }
    function Lt(r, d, u) {
      return Fe(r, d, u, !0);
    }
    function Tt(r, d, u) {
      return Fe(r, d, u, !1);
    }
    var Pt = Tt, Rt = Lt;
    U.Fragment = a, U.jsx = Pt, U.jsxs = Rt;
  }()), U;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ze;
function Yt() {
  if (ze)
    return q;
  ze = 1;
  var o = Ke, t = Symbol.for("react.element"), e = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, n = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(c, l, g) {
    var p, S = {}, f = null, k = null;
    g !== void 0 && (f = "" + g), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (k = l.ref);
    for (p in l)
      a.call(l, p) && !i.hasOwnProperty(p) && (S[p] = l[p]);
    if (c && c.defaultProps)
      for (p in l = c.defaultProps, l)
        S[p] === void 0 && (S[p] = l[p]);
    return { $$typeof: t, type: c, key: f, ref: k, props: S, _owner: n.current };
  }
  return q.Fragment = e, q.jsx = s, q.jsxs = s, q;
}
process.env.NODE_ENV === "production" ? pe.exports = Yt() : pe.exports = jt();
var v = pe.exports, P;
let w = (P = class extends Date {
  constructor(e = null, a = "YYYY-MM-DD", n = "en-US") {
    super(P.parseDateTime(e, a, n));
    E(this, "lang");
    this.lang = n;
  }
  static parseDateTime(e, a = "YYYY-MM-DD", n = "en-US") {
    if (!e)
      return new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
    if (e instanceof P)
      return e.toJSDate();
    if (e instanceof Date)
      return e;
    if (/^-?\d{10,}$/.test(String(e)))
      return new Date(Number(e));
    if (typeof e == "string") {
      const i = [];
      let s = null;
      for (; (s = P.regex.exec(a)) != null; )
        s[1] !== "\\" && i.push(s);
      if (i.length) {
        const c = { year: null, month: null, shortMonth: null, longMonth: null, day: null, hour: 0, minute: 0, second: 0, ampm: null, value: "" };
        i[0].index > 0 && (c.value += ".*?");
        for (const [g, p] of Object.entries(i)) {
          const S = Number(g), { group: f, pattern: k } = P.formatPatterns(p[0], n);
          c[f] = S + 1, c.value += k, c.value += ".*?";
        }
        const l = new RegExp(`^${c.value}$`);
        if (l.test(e)) {
          const g = l.exec(e), p = Number(g[c.year]);
          let S = null;
          c.month ? S = Number(g[c.month]) - 1 : c.shortMonth ? S = P.shortMonths(n).indexOf(g[c.shortMonth]) : c.longMonth && (S = P.longMonths(n).indexOf(g[c.longMonth]));
          const f = Number(g[c.day]) || 1, k = Number(g[c.hour]);
          let m = Number.isNaN(k) ? 0 : k;
          const D = Number(g[c.minute]), A = Number.isNaN(D) ? 0 : D, N = Number(g[c.second]), R = Number.isNaN(N) ? 0 : N, I = g[c.ampm];
          return I && I === "PM" && (m += 12, m === 24 && (m = 0)), new Date(p, S, f, m, A, R, 0);
        }
      }
    }
    return new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
  }
  static shortMonths(e) {
    return P.MONTH_JS.map((a) => new Date(2019, a).toLocaleString(e, { month: "short" }));
  }
  static longMonths(e) {
    return P.MONTH_JS.map((a) => new Date(2019, a).toLocaleString(e, { month: "long" }));
  }
  static formatPatterns(e, a) {
    switch (e) {
      case "YY":
      case "YYYY":
        return { group: "year", pattern: `(\\d{${e.length}})` };
      case "M":
        return { group: "month", pattern: "(\\d{1,2})" };
      case "MM":
        return { group: "month", pattern: "(\\d{2})" };
      case "MMM":
        return { group: "shortMonth", pattern: `(${P.shortMonths(a).join("|")})` };
      case "MMMM":
        return { group: "longMonth", pattern: `(${P.longMonths(a).join("|")})` };
      case "D":
        return { group: "day", pattern: "(\\d{1,2})" };
      case "DD":
        return { group: "day", pattern: "(\\d{2})" };
      case "h":
      case "H":
        return { group: "hour", pattern: "(\\d{1,2})" };
      case "hh":
      case "HH":
        return { group: "hour", pattern: "(\\d{2})" };
      case "m":
        return { group: "minute", pattern: "(\\d{1,2})" };
      case "mm":
        return { group: "minute", pattern: "(\\d{2})" };
      case "s":
        return { group: "second", pattern: "(\\d{1,2})" };
      case "ss":
        return { group: "second", pattern: "(\\d{2})" };
      case "a":
      case "A":
        return { group: "ampm", pattern: "(AM|PM|am|pm)" };
    }
  }
  getWeek(e) {
    const a = new Date(this.midnight_ts(this)), n = (this.getDay() + (7 - e)) % 7;
    a.setDate(a.getDate() - n);
    const i = a.getTime();
    return a.setMonth(0, 1), a.getDay() !== e && a.setMonth(0, 1 + (4 - a.getDay() + 7) % 7), 1 + Math.ceil((i - a.getTime()) / 6048e5);
  }
  clone() {
    return new P(this);
  }
  toJSDate() {
    return new Date(this);
  }
  inArray(e, a = "[]") {
    return e.some((n) => n instanceof Array ? this.isBetween(n[0], n[1], a) : this.isSame(n, "day"));
  }
  isBetween(e, a, n = "()") {
    switch (n) {
      default:
      case "()":
        return this.midnight_ts(this) > this.midnight_ts(e) && this.midnight_ts(this) < this.midnight_ts(a);
      case "[)":
        return this.midnight_ts(this) >= this.midnight_ts(e) && this.midnight_ts(this) < this.midnight_ts(a);
      case "(]":
        return this.midnight_ts(this) > this.midnight_ts(e) && this.midnight_ts(this) <= this.midnight_ts(a);
      case "[]":
        return this.midnight_ts() >= this.midnight_ts(e) && this.midnight_ts() <= this.midnight_ts(a);
    }
  }
  isBefore(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        return new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
      case "month":
      case "months":
        return new Date(e.getFullYear(), e.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();
      case "year":
      case "years":
        return e.getFullYear() > this.getFullYear();
    }
    throw new Error("isBefore: Invalid unit!");
  }
  isSameOrBefore(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        return new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
      case "month":
      case "months":
        return new Date(e.getFullYear(), e.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
    }
    throw new Error("isSameOrBefore: Invalid unit!");
  }
  isAfter(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(e.getFullYear(), e.getMonth(), 1).getTime();
      case "year":
      case "years":
        return this.getFullYear() > e.getFullYear();
    }
    throw new Error("isAfter: Invalid unit!");
  }
  isSameOrAfter(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(e.getFullYear(), e.getMonth(), 1).getTime();
    }
    throw new Error("isSameOrAfter: Invalid unit!");
  }
  isSame(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(e.getFullYear(), e.getMonth(), 1).getTime();
    }
    throw new Error("isSame: Invalid unit!");
  }
  add(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        this.setDate(this.getDate() + e);
        break;
      case "month":
      case "months":
        this.setMonth(this.getMonth() + e);
    }
    return this;
  }
  subtract(e, a = "days") {
    switch (a) {
      case "day":
      case "days":
        this.setDate(this.getDate() - e);
        break;
      case "month":
      case "months":
        this.setMonth(this.getMonth() - e);
    }
    return this;
  }
  diff(e, a = "days") {
    switch (a) {
      default:
      case "day":
      case "days":
        return Math.round((this.midnight_ts() - this.midnight_ts(e)) / 864e5);
      case "month":
      case "months":
        let n = 12 * (e.getFullYear() - this.getFullYear());
        return n -= e.getMonth(), n += this.getMonth(), n;
    }
  }
  format(e, a = "en-US") {
    let n = "";
    const i = [];
    let s = null;
    for (; (s = P.regex.exec(e)) != null; )
      s[1] !== "\\" && i.push(s);
    if (i.length) {
      i[0].index > 0 && (n += e.substring(0, i[0].index));
      for (const [c, l] of Object.entries(i)) {
        const g = Number(c);
        n += this.formatTokens(l[0], a), i[g + 1] && (n += e.substring(l.index + l[0].length, i[g + 1].index)), g === i.length - 1 && (n += e.substring(l.index + l[0].length));
      }
    }
    return n.replace(/\\/g, "");
  }
  midnight_ts(e) {
    return e ? new Date(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0, 0).getTime() : new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
  }
  formatTokens(e, a) {
    switch (e) {
      case "YY":
        return String(this.getFullYear()).slice(-2);
      case "YYYY":
        return String(this.getFullYear());
      case "M":
        return String(this.getMonth() + 1);
      case "MM":
        return `0${this.getMonth() + 1}`.slice(-2);
      case "MMM":
        return P.shortMonths(a)[this.getMonth()];
      case "MMMM":
        return P.longMonths(a)[this.getMonth()];
      case "D":
        return String(this.getDate());
      case "DD":
        return `0${this.getDate()}`.slice(-2);
      case "H":
        return String(this.getHours());
      case "HH":
        return `0${this.getHours()}`.slice(-2);
      case "h":
        return String(this.getHours() % 12 || 12);
      case "hh":
        return `0${this.getHours() % 12 || 12}`.slice(-2);
      case "m":
        return String(this.getMinutes());
      case "mm":
        return `0${this.getMinutes()}`.slice(-2);
      case "s":
        return String(this.getSeconds());
      case "ss":
        return `0${this.getSeconds()}`.slice(-2);
      case "a":
        return this.getHours() < 12 || this.getHours() === 24 ? "am" : "pm";
      case "A":
        return this.getHours() < 12 || this.getHours() === 24 ? "AM" : "PM";
      default:
        return "";
    }
  }
}, E(P, "regex", /(\\)?(Y{2,4}|M{1,4}|D{1,2}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|A|a)/g), E(P, "MONTH_JS", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]), P);
class Ft {
  constructor(t) {
    E(this, "picker");
    this.picker = t;
  }
  render(t, e) {
    t || (t = new w()), t.setDate(1), t.setHours(0, 0, 0, 0), typeof this[`get${e}View`] == "function" && this[`get${e}View`](t);
  }
  getContainerView(t) {
    this.picker.ui.container.innerHTML = "", this.picker.options.header && this.picker.trigger("render", { date: t.clone(), view: "Header" }), this.picker.trigger("render", { date: t.clone(), view: "Main" }), this.picker.options.autoApply || this.picker.trigger("render", { date: t.clone(), view: "Footer" });
  }
  getHeaderView(t) {
    const e = document.createElement("header");
    this.picker.options.header instanceof HTMLElement && e.appendChild(this.picker.options.header), typeof this.picker.options.header == "string" && (e.innerHTML = this.picker.options.header), this.picker.ui.container.appendChild(e), this.picker.trigger("view", { target: e, date: t.clone(), view: "Header" });
  }
  getMainView(t) {
    const e = document.createElement("main");
    this.picker.ui.container.appendChild(e);
    const a = document.createElement("div");
    a.className = `calendars grid-${this.picker.options.grid}`;
    for (let n = 0; n < this.picker.options.calendars; n++) {
      const i = document.createElement("div");
      i.className = "calendar", a.appendChild(i);
      const s = this.getCalendarHeaderView(t.clone());
      i.appendChild(s), this.picker.trigger("view", { date: t.clone(), view: "CalendarHeader", index: n, target: s });
      const c = this.getCalendarDayNamesView();
      i.appendChild(c), this.picker.trigger("view", { date: t.clone(), view: "CalendarDayNames", index: n, target: c });
      const l = this.getCalendarDaysView(t.clone());
      i.appendChild(l), this.picker.trigger("view", { date: t.clone(), view: "CalendarDays", index: n, target: l });
      const g = this.getCalendarFooterView(this.picker.options.lang, t.clone());
      i.appendChild(g), this.picker.trigger("view", { date: t.clone(), view: "CalendarFooter", index: n, target: g }), this.picker.trigger("view", { date: t.clone(), view: "CalendarItem", index: n, target: i }), t.add(1, "month");
    }
    e.appendChild(a), this.picker.trigger("view", { date: t.clone(), view: "Calendars", target: a }), this.picker.trigger("view", { date: t.clone(), view: "Main", target: e });
  }
  getFooterView(t) {
    const e = document.createElement("footer"), a = document.createElement("div");
    a.className = "footer-buttons";
    const n = document.createElement("button");
    n.className = "cancel-button unit", n.innerHTML = this.picker.options.locale.cancel, a.appendChild(n);
    const i = document.createElement("button");
    i.className = "apply-button unit", i.innerHTML = this.picker.options.locale.apply, i.disabled = !0, a.appendChild(i), e.appendChild(a), this.picker.ui.container.appendChild(e), this.picker.trigger("view", { date: t, target: e, view: "Footer" });
  }
  getCalendarHeaderView(t) {
    const e = document.createElement("div");
    e.className = "header";
    const a = document.createElement("div");
    a.className = "month-name", a.innerHTML = `<span>${t.toLocaleString(this.picker.options.lang, { month: "long" })}</span> ${t.format("YYYY")}`, e.appendChild(a);
    const n = document.createElement("button");
    n.className = "previous-button unit", n.innerHTML = this.picker.options.locale.previousMonth, e.appendChild(n);
    const i = document.createElement("button");
    return i.className = "next-button unit", i.innerHTML = this.picker.options.locale.nextMonth, e.appendChild(i), e;
  }
  getCalendarDayNamesView() {
    const t = document.createElement("div");
    t.className = "daynames-row";
    for (let e = 1; e <= 7; e++) {
      const a = 3 + this.picker.options.firstDay + e, n = document.createElement("div");
      n.className = "dayname", n.innerHTML = new Date(1970, 0, a, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, { weekday: "short" }), n.title = new Date(1970, 0, a, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, { weekday: "long" }), t.appendChild(n), this.picker.trigger("view", { dayIdx: a, view: "CalendarDayName", target: n });
    }
    return t;
  }
  getCalendarDaysView(t) {
    const e = document.createElement("div");
    e.className = "days-grid";
    const a = this.calcOffsetDays(t, this.picker.options.firstDay), n = 32 - new Date(t.getFullYear(), t.getMonth(), 32).getDate();
    for (let i = 0; i < a; i++) {
      const s = document.createElement("div");
      s.className = "offset", e.appendChild(s);
    }
    for (let i = 1; i <= n; i++) {
      t.setDate(i);
      const s = this.getCalendarDayView(t);
      e.appendChild(s), this.picker.trigger("view", { date: t, view: "CalendarDay", target: s });
    }
    return e;
  }
  getCalendarDayView(t) {
    const e = this.picker.options.date ? new w(this.picker.options.date) : null, a = new w(), n = document.createElement("div");
    return n.className = "day unit", n.innerHTML = t.format("D"), n.dataset.time = String(t.getTime()), t.isSame(a, "day") && n.classList.add("today"), [0, 6].includes(t.getDay()) && n.classList.add("weekend"), this.picker.datePicked.length ? this.picker.datePicked[0].isSame(t, "day") && n.classList.add("selected") : e && t.isSame(e, "day") && n.classList.add("selected"), this.picker.trigger("view", { date: t, view: "CalendarDay", target: n }), n;
  }
  getCalendarFooterView(t, e) {
    const a = document.createElement("div");
    return a.className = "footer", a;
  }
  calcOffsetDays(t, e) {
    let a = t.getDay() - e;
    return a < 0 && (a += 7), a;
  }
}
let It = class {
  constructor(t) {
    E(this, "picker");
    E(this, "instances", {});
    this.picker = t;
  }
  initialize() {
    const t = [];
    this.picker.options.plugins.forEach((e) => {
      typeof e == "function" ? t.push(new e()) : typeof e == "string" && typeof easepick < "u" && Object.prototype.hasOwnProperty.call(easepick, e) ? t.push(new easepick[e]()) : console.warn(`easepick: ${e} not found.`);
    }), t.sort((e, a) => e.priority > a.priority ? -1 : e.priority < a.priority || e.dependencies.length > a.dependencies.length ? 1 : e.dependencies.length < a.dependencies.length ? -1 : 0), t.forEach((e) => {
      e.attach(this.picker), this.instances[e.getName()] = e;
    });
  }
  getInstance(t) {
    return this.instances[t];
  }
  addInstance(t) {
    if (Object.prototype.hasOwnProperty.call(this.instances, t))
      console.warn(`easepick: ${t} already added.`);
    else {
      if (typeof easepick < "u" && Object.prototype.hasOwnProperty.call(easepick, t)) {
        const e = new easepick[t]();
        return e.attach(this.picker), this.instances[e.getName()] = e, e;
      }
      if (this.getPluginFn(t) !== "undefined") {
        const e = new (this.getPluginFn(t))();
        return e.attach(this.picker), this.instances[e.getName()] = e, e;
      }
      console.warn(`easepick: ${t} not found.`);
    }
    return null;
  }
  removeInstance(t) {
    return t in this.instances && this.instances[t].detach(), delete this.instances[t];
  }
  reloadInstance(t) {
    return this.removeInstance(t), this.addInstance(t);
  }
  getPluginFn(t) {
    return [...this.picker.options.plugins].filter((e) => typeof e == "function" && new e().getName() === t).shift();
  }
};
class $e {
  constructor(t) {
    E(this, "Calendar", new Ft(this));
    E(this, "PluginManager", new It(this));
    E(this, "calendars", []);
    E(this, "datePicked", []);
    E(this, "cssLoaded", 0);
    E(this, "binds", { hidePicker: this.hidePicker.bind(this), show: this.show.bind(this) });
    E(this, "options", { doc: document, css: [], element: null, firstDay: 1, grid: 1, calendars: 1, lang: "en-US", date: null, format: "YYYY-MM-DD", readonly: !0, autoApply: !0, header: !1, inline: !1, scrollToDate: !0, locale: { nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>', previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>', cancel: "Cancel", apply: "Apply" }, documentClick: this.binds.hidePicker, plugins: [] });
    E(this, "ui", { container: null, shadowRoot: null, wrapper: null });
    E(this, "version", "1.2.1");
    const e = { ...this.options.locale, ...t.locale };
    this.options = { ...this.options, ...t }, this.options.locale = e, this.handleOptions(), this.ui.wrapper = document.createElement("span"), this.ui.wrapper.style.display = "none", this.ui.wrapper.style.position = "absolute", this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.className = "easepick-wrapper", this.ui.wrapper.attachShadow({ mode: "open" }), this.ui.shadowRoot = this.ui.wrapper.shadowRoot, this.ui.container = document.createElement("div"), this.ui.container.className = "container", this.options.zIndex && (this.ui.container.style.zIndex = String(this.options.zIndex)), this.options.inline && (this.ui.wrapper.style.position = "relative", this.ui.container.classList.add("inline")), this.ui.shadowRoot.appendChild(this.ui.container), this.options.element.after(this.ui.wrapper), this.handleCSS(), this.options.element.addEventListener("click", this.binds.show), this.on("view", this.onView.bind(this)), this.on("render", this.onRender.bind(this)), this.PluginManager.initialize(), this.parseValues(), typeof this.options.setup == "function" && this.options.setup(this), this.on("click", this.onClick.bind(this));
    const a = this.options.scrollToDate ? this.getDate() : null;
    this.renderAll(a);
  }
  on(t, e, a = {}) {
    this.ui.container.addEventListener(t, e, a);
  }
  off(t, e, a = {}) {
    this.ui.container.removeEventListener(t, e, a);
  }
  trigger(t, e = {}) {
    return this.ui.container.dispatchEvent(new CustomEvent(t, { detail: e }));
  }
  destroy() {
    this.options.element.removeEventListener("click", this.binds.show), typeof this.options.documentClick == "function" && document.removeEventListener("click", this.options.documentClick, !0), Object.keys(this.PluginManager.instances).forEach((t) => {
      this.PluginManager.removeInstance(t);
    }), this.ui.wrapper.remove();
  }
  onRender(t) {
    const { view: e, date: a } = t.detail;
    this.Calendar.render(a, e);
  }
  onView(t) {
    const { view: e, target: a } = t.detail;
    e === "Footer" && this.datePicked.length && (a.querySelector(".apply-button").disabled = !1);
  }
  onClickHeaderButton(t) {
    this.isCalendarHeaderButton(t) && (t.classList.contains("next-button") ? this.calendars[0].add(1, "month") : this.calendars[0].subtract(1, "month"), this.renderAll(this.calendars[0]));
  }
  onClickCalendarDay(t) {
    if (this.isCalendarDay(t)) {
      const e = new w(t.dataset.time);
      this.options.autoApply ? (this.setDate(e), this.trigger("select", { date: this.getDate() }), this.hide()) : (this.datePicked[0] = e, this.trigger("preselect", { date: this.getDate() }), this.renderAll());
    }
  }
  onClickApplyButton(t) {
    if (this.isApplyButton(t)) {
      if (this.datePicked[0] instanceof Date) {
        const e = this.datePicked[0].clone();
        this.setDate(e);
      }
      this.hide(), this.trigger("select", { date: this.getDate() });
    }
  }
  onClickCancelButton(t) {
    this.isCancelButton(t) && this.hide();
  }
  onClick(t) {
    const e = t.target;
    if (e instanceof HTMLElement) {
      const a = e.closest(".unit");
      if (!(a instanceof HTMLElement))
        return;
      this.onClickHeaderButton(a), this.onClickCalendarDay(a), this.onClickApplyButton(a), this.onClickCancelButton(a);
    }
  }
  isShown() {
    return this.ui.container.classList.contains("inline") || this.ui.container.classList.contains("show");
  }
  show(t) {
    if (this.isShown())
      return;
    const e = t && "target" in t ? t.target : this.options.element, { top: a, left: n } = this.adjustPosition(e);
    this.ui.container.style.top = `${a}px`, this.ui.container.style.left = `${n}px`, this.ui.container.classList.add("show"), this.trigger("show", { target: e });
  }
  hide() {
    this.ui.container.classList.remove("show"), this.datePicked.length = 0, this.renderAll(), this.trigger("hide");
  }
  setDate(t) {
    const e = new w(t, this.options.format);
    this.options.date = e.clone(), this.updateValues(), this.calendars.length && this.renderAll();
  }
  getDate() {
    return this.options.date instanceof w ? this.options.date.clone() : null;
  }
  parseValues() {
    this.options.date ? this.setDate(this.options.date) : this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.setDate(this.options.element.value), this.options.date instanceof Date || (this.options.date = null);
  }
  updateValues() {
    const t = this.getDate(), e = t instanceof Date ? t.format(this.options.format, this.options.lang) : "", a = this.options.element;
    a instanceof HTMLInputElement ? a.value = e : a instanceof HTMLElement && (a.innerText = e);
  }
  hidePicker(t) {
    let e = t.target, a = null;
    e.shadowRoot && (e = t.composedPath()[0], a = e.getRootNode().host), this.isShown() && a !== this.ui.wrapper && e !== this.options.element && this.hide();
  }
  renderAll(t) {
    this.trigger("render", { view: "Container", date: (t || this.calendars[0]).clone() });
  }
  isCalendarHeaderButton(t) {
    return ["previous-button", "next-button"].some((e) => t.classList.contains(e));
  }
  isCalendarDay(t) {
    return t.classList.contains("day");
  }
  isApplyButton(t) {
    return t.classList.contains("apply-button");
  }
  isCancelButton(t) {
    return t.classList.contains("cancel-button");
  }
  gotoDate(t) {
    const e = new w(t, this.options.format);
    e.setDate(1), this.calendars[0] = e.clone(), this.renderAll();
  }
  clear() {
    this.options.date = null, this.datePicked.length = 0, this.updateValues(), this.renderAll(), this.trigger("clear");
  }
  handleOptions() {
    this.options.element instanceof HTMLElement || (this.options.element = this.options.doc.querySelector(this.options.element)), typeof this.options.documentClick == "function" && document.addEventListener("click", this.options.documentClick, !0), this.options.element instanceof HTMLInputElement && (this.options.element.readOnly = this.options.readonly), this.options.date ? this.calendars[0] = new w(this.options.date, this.options.format) : this.calendars[0] = new w();
  }
  handleCSS() {
    if (Array.isArray(this.options.css))
      this.options.css.forEach((t) => {
        const e = document.createElement("link");
        e.href = t, e.rel = "stylesheet";
        const a = () => {
          this.cssLoaded++, this.cssLoaded === this.options.css.length && (this.ui.wrapper.style.display = "");
        };
        e.addEventListener("load", a), e.addEventListener("error", a), this.ui.shadowRoot.append(e);
      });
    else if (typeof this.options.css == "string") {
      const t = document.createElement("style"), e = document.createTextNode(this.options.css);
      t.appendChild(e), this.ui.shadowRoot.append(t), this.ui.wrapper.style.display = "";
    } else
      typeof this.options.css == "function" && (this.options.css.call(this, this), this.ui.wrapper.style.display = "");
  }
  adjustPosition(t) {
    const e = t.getBoundingClientRect(), a = this.ui.wrapper.getBoundingClientRect();
    this.ui.container.classList.add("calc");
    const n = this.ui.container.getBoundingClientRect();
    this.ui.container.classList.remove("calc");
    let i = e.bottom - a.bottom, s = e.left - a.left;
    return typeof window < "u" && (window.innerHeight < i + n.height && i - n.height >= 0 && (i = e.top - a.top - n.height), window.innerWidth < s + n.width && e.right - n.width >= 0 && (s = e.right - a.right - n.width)), { left: s, top: i };
  }
}
var he = Object.freeze({ __proto__: null, Core: $e, create: $e });
class Xe {
  constructor() {
    E(this, "picker");
    E(this, "options");
    E(this, "priority", 0);
    E(this, "dependencies", []);
  }
  attach(t) {
    const e = this.getName(), a = { ...this.options };
    this.options = { ...this.options, ...t.options[e] || {} };
    for (const i of Object.keys(a))
      if (a[i] !== null && typeof a[i] == "object" && Object.keys(a[i]).length && e in t.options && i in t.options[e]) {
        const s = { ...t.options[e][i] };
        s !== null && typeof s == "object" && Object.keys(s).length && Object.keys(s).every((c) => Object.keys(a[i]).includes(c)) && (this.options[i] = { ...a[i], ...s });
      }
    if (this.picker = t, this.dependenciesNotFound()) {
      const i = this.dependencies.filter((s) => !this.pluginsAsStringArray().includes(s));
      return void console.warn(`${this.getName()}: required dependencies (${i.join(", ")}).`);
    }
    const n = this.camelCaseToKebab(this.getName());
    this.picker.ui.container.classList.add(n), this.onAttach();
  }
  detach() {
    const t = this.camelCaseToKebab(this.getName());
    this.picker.ui.container.classList.remove(t), typeof this.onDetach == "function" && this.onDetach();
  }
  dependenciesNotFound() {
    return this.dependencies.length && !this.dependencies.every((t) => this.pluginsAsStringArray().includes(t));
  }
  pluginsAsStringArray() {
    return this.picker.options.plugins.map((t) => typeof t == "function" ? new t().getName() : t);
  }
  camelCaseToKebab(t) {
    return t.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
  }
}
class fe extends Xe {
  constructor() {
    super(...arguments);
    E(this, "priority", 1);
    E(this, "binds", { onView: this.onView.bind(this) });
    E(this, "options", { minDate: null, maxDate: null, minDays: null, maxDays: null, selectForward: null, selectBackward: null, presets: !0, inseparable: !1, filter: null });
  }
  getName() {
    return "LockPlugin";
  }
  onAttach() {
    if (this.options.minDate && (this.options.minDate = new w(this.options.minDate, this.picker.options.format, this.picker.options.lang)), this.options.maxDate && (this.options.maxDate = new w(this.options.maxDate, this.picker.options.format, this.picker.options.lang), this.options.maxDate instanceof w && this.picker.options.calendars > 1 && this.picker.calendars[0].isSame(this.options.maxDate, "month"))) {
      const e = this.picker.calendars[0].clone().subtract(1, "month");
      this.picker.gotoDate(e);
    }
    if ((this.options.minDays || this.options.maxDays || this.options.selectForward || this.options.selectBackward) && !this.picker.options.plugins.includes("RangePlugin")) {
      const e = ["minDays", "maxDays", "selectForward", "selectBackward"];
      console.warn(`${this.getName()}: options ${e.join(", ")} required RangePlugin.`);
    }
    this.picker.on("view", this.binds.onView);
  }
  onDetach() {
    this.picker.off("view", this.binds.onView);
  }
  onView(e) {
    const { view: a, target: n, date: i } = e.detail;
    if (a === "CalendarHeader" && (this.options.minDate instanceof w && i.isSameOrBefore(this.options.minDate, "month") && n.classList.add("no-previous-month"), this.options.maxDate instanceof w && i.isSameOrAfter(this.options.maxDate, "month") && n.classList.add("no-next-month")), a === "CalendarDay") {
      const s = this.picker.datePicked.length ? this.picker.datePicked[0] : null;
      if (this.testFilter(i))
        return void n.classList.add("locked");
      if (this.options.inseparable) {
        if (this.options.minDays) {
          const c = i.clone().subtract(this.options.minDays - 1, "day"), l = i.clone().add(this.options.minDays - 1, "day");
          let g = !1, p = !1;
          for (; c.isBefore(i, "day"); ) {
            if (this.testFilter(c)) {
              g = !0;
              break;
            }
            c.add(1, "day");
          }
          for (; l.isAfter(i, "day"); ) {
            if (this.testFilter(l)) {
              p = !0;
              break;
            }
            l.subtract(1, "day");
          }
          g && p && n.classList.add("not-available");
        }
        this.rangeIsNotAvailable(i, s) && n.classList.add("not-available");
      }
      this.dateIsNotAvailable(i, s) && n.classList.add("not-available");
    }
    if (this.options.presets && a === "PresetPluginButton") {
      const s = new w(Number(n.dataset.start)), c = new w(Number(n.dataset.end)), l = c.diff(s, "day"), g = this.options.minDays && l < this.options.minDays, p = this.options.maxDays && l > this.options.maxDays;
      (g || p || this.lockMinDate(s) || this.lockMaxDate(s) || this.lockMinDate(c) || this.lockMaxDate(c) || this.rangeIsNotAvailable(s, c)) && n.setAttribute("disabled", "disabled");
    }
  }
  dateIsNotAvailable(e, a) {
    return this.lockMinDate(e) || this.lockMaxDate(e) || this.lockMinDays(e, a) || this.lockMaxDays(e, a) || this.lockSelectForward(e) || this.lockSelectBackward(e);
  }
  rangeIsNotAvailable(e, a) {
    if (!e || !a)
      return !1;
    const n = (e.isSameOrBefore(a, "day") ? e : a).clone(), i = (a.isSameOrAfter(e, "day") ? a : e).clone();
    for (; n.isSameOrBefore(i, "day"); ) {
      if (this.testFilter(n))
        return !0;
      n.add(1, "day");
    }
    return !1;
  }
  lockMinDate(e) {
    return this.options.minDate instanceof w && e.isBefore(this.options.minDate, "day");
  }
  lockMaxDate(e) {
    return this.options.maxDate instanceof w && e.isAfter(this.options.maxDate, "day");
  }
  lockMinDays(e, a) {
    if (this.options.minDays && a) {
      const n = a.clone().subtract(this.options.minDays - 1, "day"), i = a.clone().add(this.options.minDays - 1, "day");
      return e.isBetween(n, i);
    }
    return !1;
  }
  lockMaxDays(e, a) {
    if (this.options.maxDays && a) {
      const n = a.clone().subtract(this.options.maxDays, "day"), i = a.clone().add(this.options.maxDays, "day");
      return !e.isBetween(n, i);
    }
    return !1;
  }
  lockSelectForward(e) {
    if (this.picker.datePicked.length === 1 && this.options.selectForward) {
      const a = this.picker.datePicked[0].clone();
      return e.isBefore(a, "day");
    }
    return !1;
  }
  lockSelectBackward(e) {
    if (this.picker.datePicked.length === 1 && this.options.selectBackward) {
      const a = this.picker.datePicked[0].clone();
      return e.isAfter(a, "day");
    }
    return !1;
  }
  testFilter(e) {
    return typeof this.options.filter == "function" && this.options.filter(e, this.picker.datePicked);
  }
}
class Bt extends Xe {
  constructor() {
    super(...arguments);
    E(this, "tooltipElement");
    E(this, "triggerElement");
    E(this, "binds", { setStartDate: this.setStartDate.bind(this), setEndDate: this.setEndDate.bind(this), setDateRange: this.setDateRange.bind(this), getStartDate: this.getStartDate.bind(this), getEndDate: this.getEndDate.bind(this), onView: this.onView.bind(this), onShow: this.onShow.bind(this), onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClickCalendarDay: this.onClickCalendarDay.bind(this), onClickApplyButton: this.onClickApplyButton.bind(this), parseValues: this.parseValues.bind(this), updateValues: this.updateValues.bind(this), clear: this.clear.bind(this) });
    E(this, "options", { elementEnd: null, startDate: null, endDate: null, repick: !1, strict: !0, delimiter: " - ", tooltip: !0, tooltipNumber: (e) => e, locale: { zero: "", one: "day", two: "", few: "", many: "", other: "days" }, documentClick: this.hidePicker.bind(this) });
  }
  getName() {
    return "RangePlugin";
  }
  onAttach() {
    this.binds._setStartDate = this.picker.setStartDate, this.binds._setEndDate = this.picker.setEndDate, this.binds._setDateRange = this.picker.setDateRange, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, this.binds._parseValues = this.picker.parseValues, this.binds._updateValues = this.picker.updateValues, this.binds._clear = this.picker.clear, this.binds._onClickCalendarDay = this.picker.onClickCalendarDay, this.binds._onClickApplyButton = this.picker.onClickApplyButton, Object.defineProperties(this.picker, { setStartDate: { configurable: !0, value: this.binds.setStartDate }, setEndDate: { configurable: !0, value: this.binds.setEndDate }, setDateRange: { configurable: !0, value: this.binds.setDateRange }, getStartDate: { configurable: !0, value: this.binds.getStartDate }, getEndDate: { configurable: !0, value: this.binds.getEndDate }, parseValues: { configurable: !0, value: this.binds.parseValues }, updateValues: { configurable: !0, value: this.binds.updateValues }, clear: { configurable: !0, value: this.binds.clear }, onClickCalendarDay: { configurable: !0, value: this.binds.onClickCalendarDay }, onClickApplyButton: { configurable: !0, value: this.binds.onClickApplyButton } }), this.options.elementEnd && (this.options.elementEnd instanceof HTMLElement || (this.options.elementEnd = this.picker.options.doc.querySelector(this.options.elementEnd)), this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.readOnly = this.picker.options.readonly), typeof this.picker.options.documentClick == "function" && (document.removeEventListener("click", this.picker.options.documentClick, !0), typeof this.options.documentClick == "function" && document.addEventListener("click", this.options.documentClick, !0)), this.options.elementEnd.addEventListener("click", this.picker.show.bind(this.picker))), this.options.repick = this.options.repick && this.options.elementEnd instanceof HTMLElement, this.picker.options.date = null, this.picker.on("view", this.binds.onView), this.picker.on("show", this.binds.onShow), this.picker.on("mouseenter", this.binds.onMouseEnter, !0), this.picker.on("mouseleave", this.binds.onMouseLeave, !0), this.checkIntlPluralLocales();
  }
  onDetach() {
    Object.defineProperties(this.picker, { setStartDate: { configurable: !0, value: this.binds._setStartDate }, setEndDate: { configurable: !0, value: this.binds._setEndDate }, setDateRange: { configurable: !0, value: this.binds._setDateRange }, getStartDate: { configurable: !0, value: this.binds._getStartDate }, getEndDate: { configurable: !0, value: this.binds._getEndDate }, parseValues: { configurable: !0, value: this.binds._parseValues }, updateValues: { configurable: !0, value: this.binds._updateValues }, clear: { configurable: !0, value: this.binds._clear }, onClickCalendarDay: { configurable: !0, value: this.binds._onClickCalendarDay }, onClickApplyButton: { configurable: !0, value: this.binds._onClickApplyButton } }), this.picker.off("view", this.binds.onView), this.picker.off("show", this.binds.onShow), this.picker.off("mouseenter", this.binds.onMouseEnter, !0), this.picker.off("mouseleave", this.binds.onMouseLeave, !0);
  }
  parseValues() {
    if (this.options.startDate || this.options.endDate)
      this.options.strict ? this.options.startDate && this.options.endDate ? this.setDateRange(this.options.startDate, this.options.endDate) : (this.options.startDate = null, this.options.endDate = null) : (this.options.startDate && this.setStartDate(this.options.startDate), this.options.endDate && this.setEndDate(this.options.endDate));
    else if (this.options.elementEnd)
      this.options.strict ? this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setDateRange(this.picker.options.element.value, this.options.elementEnd.value) : (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.setStartDate(this.picker.options.element.value), this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setEndDate(this.options.elementEnd.value));
    else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
      const [e, a] = this.picker.options.element.value.split(this.options.delimiter);
      this.options.strict ? e && a && this.setDateRange(e, a) : (e && this.setStartDate(e), a && this.setEndDate(a));
    }
  }
  updateValues() {
    const e = this.picker.options.element, a = this.options.elementEnd, n = this.picker.getStartDate(), i = this.picker.getEndDate(), s = n instanceof Date ? n.format(this.picker.options.format, this.picker.options.lang) : "", c = i instanceof Date ? i.format(this.picker.options.format, this.picker.options.lang) : "";
    if (a)
      e instanceof HTMLInputElement ? e.value = s : e instanceof HTMLElement && (e.innerText = s), a instanceof HTMLInputElement ? a.value = c : a instanceof HTMLElement && (a.innerText = c);
    else {
      const l = `${s}${s || c ? this.options.delimiter : ""}${c}`;
      e instanceof HTMLInputElement ? e.value = l : e instanceof HTMLElement && (e.innerText = l);
    }
  }
  clear() {
    this.options.startDate = null, this.options.endDate = null, this.picker.datePicked.length = 0, this.updateValues(), this.picker.renderAll(), this.picker.trigger("clear");
  }
  onShow(e) {
    const { target: a } = e.detail;
    this.triggerElement = a, this.picker.options.scrollToDate && this.getStartDate() instanceof Date && this.picker.gotoDate(this.getStartDate()), this.initializeRepick();
  }
  onView(e) {
    const { view: a, target: n } = e.detail;
    if (a === "Main" && (this.tooltipElement = document.createElement("span"), this.tooltipElement.className = "range-plugin-tooltip", n.appendChild(this.tooltipElement)), a === "CalendarDay") {
      const i = new w(n.dataset.time), s = this.picker.datePicked, c = s.length ? this.picker.datePicked[0] : this.getStartDate(), l = s.length ? this.picker.datePicked[1] : this.getEndDate();
      c && c.isSame(i, "day") && n.classList.add("start"), c && l && (l.isSame(i, "day") && n.classList.add("end"), i.isBetween(c, l) && n.classList.add("in-range"));
    }
    if (a === "Footer") {
      const i = this.picker.datePicked.length === 1 && !this.options.strict || this.picker.datePicked.length === 2;
      n.querySelector(".apply-button").disabled = !i;
    }
  }
  hidePicker(e) {
    let a = e.target, n = null;
    a.shadowRoot && (a = e.composedPath()[0], n = a.getRootNode().host), this.picker.isShown() && n !== this.picker.ui.wrapper && a !== this.picker.options.element && a !== this.options.elementEnd && this.picker.hide();
  }
  setStartDate(e) {
    const a = new w(e, this.picker.options.format);
    this.options.startDate = a ? a.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  setEndDate(e) {
    const a = new w(e, this.picker.options.format);
    this.options.endDate = a ? a.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  setDateRange(e, a) {
    const n = new w(e, this.picker.options.format), i = new w(a, this.picker.options.format);
    this.options.startDate = n ? n.clone() : null, this.options.endDate = i ? i.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  getStartDate() {
    return this.options.startDate instanceof Date ? this.options.startDate.clone() : null;
  }
  getEndDate() {
    return this.options.endDate instanceof Date ? this.options.endDate.clone() : null;
  }
  onMouseEnter(e) {
    const a = e.target;
    if (a instanceof HTMLElement) {
      this.isContainer(a) && this.initializeRepick();
      const n = a.closest(".unit");
      if (!(n instanceof HTMLElement))
        return;
      if (this.picker.isCalendarDay(n)) {
        if (this.picker.datePicked.length !== 1)
          return;
        let i = this.picker.datePicked[0].clone(), s = new w(n.dataset.time), c = !1;
        if (i.isAfter(s, "day")) {
          const l = i.clone();
          i = s.clone(), s = l.clone(), c = !0;
        }
        if ([...this.picker.ui.container.querySelectorAll(".day")].forEach((l) => {
          const g = new w(l.dataset.time), p = this.picker.Calendar.getCalendarDayView(g);
          g.isBetween(i, s) && p.classList.add("in-range"), g.isSame(this.picker.datePicked[0], "day") && (p.classList.add("start"), p.classList.toggle("flipped", c)), l === n && (p.classList.add("end"), p.classList.toggle("flipped", c)), l.className = p.className;
        }), this.options.tooltip) {
          const l = this.options.tooltipNumber(s.diff(i, "day") + 1);
          if (l > 0) {
            const g = new Intl.PluralRules(this.picker.options.lang).select(l), p = `${l} ${this.options.locale[g]}`;
            this.showTooltip(n, p);
          } else
            this.hideTooltip();
        }
      }
    }
  }
  onMouseLeave(e) {
    if (this.isContainer(e.target) && this.options.repick) {
      const a = this.getStartDate(), n = this.getEndDate();
      a && n && (this.picker.datePicked.length = 0, this.picker.renderAll());
    }
  }
  onClickCalendarDay(e) {
    if (this.picker.isCalendarDay(e)) {
      this.picker.datePicked.length === 2 && (this.picker.datePicked.length = 0);
      const a = new w(e.dataset.time);
      if (this.picker.datePicked[this.picker.datePicked.length] = a, this.picker.datePicked.length === 2 && this.picker.datePicked[0].isAfter(this.picker.datePicked[1])) {
        const n = this.picker.datePicked[1].clone();
        this.picker.datePicked[1] = this.picker.datePicked[0].clone(), this.picker.datePicked[0] = n.clone();
      }
      this.picker.datePicked.length !== 1 && this.picker.options.autoApply || this.picker.trigger("preselect", { start: this.picker.datePicked[0] instanceof Date ? this.picker.datePicked[0].clone() : null, end: this.picker.datePicked[1] instanceof Date ? this.picker.datePicked[1].clone() : null }), this.picker.datePicked.length === 1 && (!this.options.strict && this.picker.options.autoApply && (this.picker.options.element === this.triggerElement && this.setStartDate(this.picker.datePicked[0]), this.options.elementEnd === this.triggerElement && this.setEndDate(this.picker.datePicked[0]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() })), this.picker.renderAll()), this.picker.datePicked.length === 2 && (this.picker.options.autoApply ? (this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() }), this.picker.hide()) : (this.hideTooltip(), this.picker.renderAll()));
    }
  }
  onClickApplyButton(e) {
    this.picker.isApplyButton(e) && (this.picker.datePicked.length !== 1 || this.options.strict || (this.picker.options.element === this.triggerElement && (this.options.endDate = null, this.setStartDate(this.picker.datePicked[0])), this.options.elementEnd === this.triggerElement && (this.options.startDate = null, this.setEndDate(this.picker.datePicked[0]))), this.picker.datePicked.length === 2 && this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() }), this.picker.hide());
  }
  showTooltip(e, a) {
    this.tooltipElement.style.visibility = "visible", this.tooltipElement.innerHTML = a;
    const n = this.picker.ui.container.getBoundingClientRect(), i = this.tooltipElement.getBoundingClientRect(), s = e.getBoundingClientRect();
    let c = s.top, l = s.left;
    c -= n.top, l -= n.left, c -= i.height, l -= i.width / 2, l += s.width / 2, this.tooltipElement.style.top = `${c}px`, this.tooltipElement.style.left = `${l}px`;
  }
  hideTooltip() {
    this.tooltipElement.style.visibility = "hidden";
  }
  checkIntlPluralLocales() {
    if (!this.options.tooltip)
      return;
    const e = [.../* @__PURE__ */ new Set([new Intl.PluralRules(this.picker.options.lang).select(0), new Intl.PluralRules(this.picker.options.lang).select(1), new Intl.PluralRules(this.picker.options.lang).select(2), new Intl.PluralRules(this.picker.options.lang).select(6), new Intl.PluralRules(this.picker.options.lang).select(18)])], a = Object.keys(this.options.locale);
    e.every((n) => a.includes(n)) || console.warn(`${this.getName()}: provide locales (${e.join(", ")}) for correct tooltip text.`);
  }
  initializeRepick() {
    if (!this.options.repick)
      return;
    const e = this.getStartDate(), a = this.getEndDate();
    a && this.triggerElement === this.picker.options.element && (this.picker.datePicked[0] = a), e && this.triggerElement === this.options.elementEnd && (this.picker.datePicked[0] = e);
  }
  isContainer(e) {
    return e === this.picker.ui.container;
  }
}
function zt(o) {
  const t = M.useRef(null), [e] = M.useState(() => Math.ceil(Math.random() * 1e3)), a = M.useCallback(function(c) {
    if (!c.target)
      return;
    const l = c.target;
    if (l.classList.contains("day") && !l.classList.contains("locked") && !l.classList.contains("not-available")) {
      const g = l.getAttribute("data-time"), p = new Date(Number(g));
      o({
        start: p,
        end: p
      }), t.current && (t.current.setStartDate(p), t.current.setEndDate(p));
    }
  }, []), n = M.useCallback(function(c) {
    const {
      detail: { start: l, end: g }
    } = c;
    o({
      start: l,
      end: g
    });
  }, []), i = M.useCallback(function(c) {
    if (!t.current)
      return;
    const l = t.current.getStartDate(), g = t.current.getEndDate();
    if (l && g && g.isSame(l) && c.currentTarget) {
      const S = c.currentTarget.querySelector(
        `[data-time="${l.getTime()}"]`
      );
      S == null || S.classList.add("single-day");
    }
  }, []);
  return {
    onClick: a,
    onRender: i,
    onSelect: n,
    picker: t,
    startId: `start_${e}`,
    endId: `end_${e}`
  };
}
function $t(o, t) {
  return {
    formattedPeriod: M.useMemo(() => {
      if (!t)
        return "";
      const { start: a, end: n } = t, i = Intl.DateTimeFormat(o, {
        day: "numeric",
        month: "short"
      }), s = i.format(a);
      return Nt(a, n) ? s : `${s} - ${i.format(n)}`;
    }, [o, t])
  };
}
const Ht = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars .calendar:nth-child(n+2){display:block}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar{padding:8px}.calendar>.header{padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{padding:0;border:none;border-radius:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1)}.calendar>.header .previous-button,.calendar>.header .next-button{display:none}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row{display:none}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}@media (min-width: 992px){.calendars{padding:40px 16px 24px;grid-template-columns:repeat(2,1fr)}.calendars .calendar>.daynames-row{display:grid}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button{display:flex;position:absolute;top:5px}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button>svg,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button>svg{height:24px;width:auto}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:first-child>.header .previous-button{left:0}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar:nth-child(2)>.header .next-button{right:0}.calendars .calendar{padding:8px 24px}.calendars .calendar:nth-child(n+3){display:none}}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}', Vt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars{padding:24px 0 16px}@media (max-width: 480px){.calendars{padding:8px 0}}.calendars .calendar:nth-child(n+2){display:none}@media (min-width: 992px){.calendars .calendar:nth-child(n+2){display:block}}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}.calendars.grid-2{grid-template-columns:none}@media (min-width: 992px){.calendars{padding:32px 16px 24px}.calendars.grid-2{grid-template-columns:repeat(2,1fr)}.calendars:not(.grid-1) .calendar>.header .next-button{visibility:hidden}}.calendar{padding:8px 24px}@media (max-width: 480px){.calendar{padding:8px}}.calendar>.header{position:relative;padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{position:absolute;top:5px;padding:0;border:none;border-radius:0}.calendar>.header button.previous-button{left:0}.calendar>.header button.next-button{right:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1);height:24px;width:auto}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.inline{min-height:unset}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}';
var te = /* @__PURE__ */ ((o) => (o[o.DISABLED = 0] = "DISABLED", o[o.ENABLED = 1] = "ENABLED", o[o.ONLY_HALF_DAY = 2] = "ONLY_HALF_DAY", o))(te || {}), B = /* @__PURE__ */ ((o) => (o.ALL_DAY = "day", o.MORNING = "morning", o.AFTERNOON = "afternoon", o.ALL_SEASON = "season", o))(B || {});
function Wt(o) {
  if (!o.settings.bookingSeasonal && o.settings.bookingHalfDay === te.DISABLED)
    return null;
  const t = o.dayDifference === 1 && o.settings.bookingHalfDay !== te.DISABLED;
  return /* @__PURE__ */ v.jsxs("div", { className: "space-y-4 mb-4", children: [
    t ? /* @__PURE__ */ v.jsxs("div", { className: "grid grid-cols-3 gap-2 sm:gap-4", children: [
      /* @__PURE__ */ v.jsx(
        Q,
        {
          label: o.labels.all_day,
          onClick: () => {
            o.onButtonClick(B.ALL_DAY);
          },
          active: o.selectedBookingPeriod === B.ALL_DAY
        }
      ),
      /* @__PURE__ */ v.jsx(
        Q,
        {
          label: o.labels.morning,
          onClick: () => {
            o.onButtonClick(B.MORNING);
          },
          active: o.selectedBookingPeriod === B.MORNING
        }
      ),
      /* @__PURE__ */ v.jsx(
        Q,
        {
          label: o.labels.afternoon,
          onClick: () => {
            o.onButtonClick(B.AFTERNOON);
          },
          active: o.selectedBookingPeriod === B.AFTERNOON
        }
      )
    ] }) : null,
    o.settings.bookingSeasonal ? /* @__PURE__ */ v.jsx(
      Q,
      {
        label: o.labels.all_season,
        onClick: () => {
          o.onButtonClick(B.ALL_SEASON);
        }
      }
    ) : null
  ] });
}
function Q(o) {
  return /* @__PURE__ */ v.jsx(
    "button",
    {
      type: "button",
      className: ge(
        "block w-full select-none rounded-sm border border-gray-300 bg-white p-2 text-center text-sm text-primary transition-colors hover:border-blue-500 hover:bg-blue-100 hover:text-blue-500 sm:px-3",
        o.className,
        { "bg-blue-100 text-blue-500 border-blue-500": o.active }
      ),
      onClick: o.onClick,
      children: o.label
    }
  );
}
const Ut = [
  new Date(2024, 0, 1),
  // monday
  new Date(2024, 0, 2),
  // tuesday
  new Date(2024, 0, 3),
  // wednesday
  new Date(2024, 0, 4),
  // thursday
  new Date(2024, 0, 5),
  // friday
  new Date(2024, 0, 6),
  // saturday
  new Date(2024, 0, 7)
  // sunday
];
function Qe(o) {
  const t = Intl.DateTimeFormat(o.locale, {
    weekday: "short"
  }), e = Intl.DateTimeFormat(o.locale, {
    weekday: "long"
  }), a = Ut.map((n) => ({
    label: t.format(n),
    title: e.format(n)
  }));
  return /* @__PURE__ */ v.jsx("div", { className: "mx-auto my-2 grid w-full max-w-xs grid-cols-7 lg:hidden", children: a.map(({ title: n, label: i }) => /* @__PURE__ */ v.jsx(
    "div",
    {
      className: "text-center text-sm capitalize text-secondary",
      title: n,
      children: i
    },
    n
  )) });
}
function qt(o) {
  if (!o)
    return 0;
  const t = j.fromJSDate(o.start), e = j.fromJSDate(o.end);
  return Math.floor(e.diff(t, ["days"]).days + 1);
}
function Jt(o, t = !1) {
  return t || !o ? 2 : Math.max(
    Ot({
      start: o.minDate,
      end: o.maxDate
    }),
    2
  );
}
function Gt(o, t) {
  const e = o ? Vt : Ht;
  return t === "portal" ? `${e}
:host {
  --color-bg-secondary: var(--gray-50, #ebeef1);
  --color-bg-inrange: var(--gray-50, #ebeef1);

  --color-fg-default: var(--gray-900, #1a1b25);
  --color-fg-primary: var(--blue-300, #00b0ff);
  --color-fg-secondary: var(--gray-300, #d4d9df);

  --color-fg-muted: var(--gray-500, #677284); /*  */

  --day-width: 48px;
  --day-height: 48px;
  --border-radius: 4px;
}` : e;
}
function or(o) {
  const {
    settings: t = {
      bookingHalfDay: te.DISABLED,
      bookingSeasonal: !1
    }
  } = o, [e, a] = M.useState(!1), [n, i] = M.useState(o.period), { onClick: s, onRender: c, onSelect: l, picker: g, startId: p, endId: S } = zt(i), { formattedPeriod: f } = $t(o.lang, n), k = qt(n);
  return M.useEffect(() => {
    const m = document.getElementById(p), D = document.getElementById(S);
    if (!m || !D) {
      console.warn("cannot find startEl or endEl", m, D);
      return;
    }
    const A = window.matchMedia("(min-width: 992px)");
    a(!A.matches);
    const N = n ? {
      startDate: n.start,
      endDate: n.end
    } : null, R = Jt(o.lockDates, o.isWidget);
    return g.current = new he.create({
      element: m,
      css: Gt(!!o.isWidget, o.mode),
      firstDay: 1,
      lang: o.lang,
      format: "YYYY-MM-DD",
      calendars: R,
      ...o.isWidget ? { grid: 2 } : {},
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [Bt, fe],
      RangePlugin: {
        elementEnd: D,
        tooltip: !1,
        ...N ? {
          startDate: new w(N.startDate),
          endDate: new w(N.endDate)
        } : {}
      },
      LockPlugin: {
        inseparable: !0,
        ...o.lockDates ? {
          minDate: o.lockDates.minDate,
          maxDate: o.lockDates.maxDate
        } : {},
        ...o.lockPluginFilter ? { filter: o.lockPluginFilter } : {}
      },
      setup: (I) => {
        I.on("click", s), I.on("render", c), I.on("select", l);
      }
    }), () => {
      g.current && (g.current.off("click", s), g.current.off("render", c), g.current.off("select", l), g.current.destroy(), g.current = null);
    };
  }, []), M.useEffect(() => {
    if (!(!g.current || !o.period))
      if (i({
        start: o.period.start,
        end: o.period.end
      }), g.current.setDateRange(o.period.start, o.period.end), e && !o.isWidget && o.defaultPeriod) {
        g.current.gotoDate(o.defaultPeriod.start);
        const m = g.current.ui.container.querySelector(
          `.day.unit[data-time="${o.period.start.getTime()}"]`
        );
        m && m.scrollIntoView({
          behavior: "instant",
          block: "center",
          inline: "center"
        });
      } else
        g.current.gotoDate(o.period.start);
  }, [o.period, o.defaultPeriod, e]), /* @__PURE__ */ v.jsxs("div", { className: "flex flex-auto flex-col", children: [
    o.isWidget ? null : /* @__PURE__ */ v.jsx(Qe, { locale: o.lang }),
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: ge("flex-auto text-center", { relative: !o.isWidget }),
        children: /* @__PURE__ */ v.jsxs(
          "div",
          {
            className: ge("inset-0 overflow-y-auto lg:static", {
              absolute: !o.isWidget
            }),
            children: [
              /* @__PURE__ */ v.jsx("input", { id: p, type: "hidden" }),
              /* @__PURE__ */ v.jsx("input", { id: S, type: "hidden" })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ v.jsx("div", { className: "relative bg-gray-25 p-4 text-center", children: /* @__PURE__ */ v.jsxs("div", { className: "mx-auto max-w-sm", children: [
      /* @__PURE__ */ v.jsx(
        Wt,
        {
          dayDifference: k,
          labels: o.labels.bookingPeriod,
          selectedBookingPeriod: o.selectedBookingPeriod ?? null,
          settings: t,
          onButtonClick: (m) => {
            var D;
            (D = o.onChangeBookingPeriod) == null || D.call(o, m);
          }
        }
      ),
      /* @__PURE__ */ v.jsxs("div", { className: "mb-2 capitalize", children: [
        f,
        " ",
        k > 0 && /* @__PURE__ */ v.jsxs("span", { className: "normal-case text-secondary", children: [
          "(",
          k,
          " ",
          k === 1 ? o.labels.day : o.labels.days,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ v.jsx(
        ee,
        {
          type: "button",
          fullWidth: !0,
          onClick: () => {
            var m;
            n && ((m = o.onConfirm) == null || m.call(o, n));
          },
          disabled: !n,
          fontSize: "lg",
          isLoading: o.isLoading,
          children: o.labels.confirmBtn
        }
      )
    ] }) })
  ] });
}
const Zt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars .calendar:nth-child(n+2){display:block}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar{padding:8px}.calendar>.header{padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{padding:0;border:none;border-radius:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1)}.calendar>.header .previous-button,.calendar>.header .next-button{display:none}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row{display:none}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}@media (min-width: 992px){.calendars{padding:40px 16px 24px;grid-template-columns:repeat(2,1fr)}.calendars .calendar>.daynames-row{display:grid}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button{display:flex;position:absolute;top:5px}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button>svg,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button>svg{height:24px;width:auto}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:first-child>.header .previous-button{left:0}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar:nth-child(2)>.header .next-button{right:0}.calendars .calendar{padding:8px 24px}.calendars .calendar:nth-child(n+3){display:none}}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}@media (min-width: 992px){.container.inline{min-height:360px}}.calendar>.days-grid>.day.absence{background-color:var(--blue-500, #046dd7);color:var(--white, #fff)}.calendar>.days-grid>.day.absence.absence-disabled{opacity:.2;cursor:default;pointer-events:none}.calendar>.days-grid>.day.sold{pointer-events:none;background-color:var(--yellow-500, #b35502);color:var(--white, #fff)}@media (min-width: 992px){.calendars{padding:8px}}';
function Kt(o, t) {
  const e = /* @__PURE__ */ new Map(), a = o.map(
    (i) => j.fromISO(i.startDate).toSeconds()
  ), n = Array.from(t).map(
    (i) => i / 1e3
  );
  return a.filter((i) => !n.includes(i)).forEach(
    (i) => e.set(He(i), "removed")
  ), n.filter((i) => !a.includes(i)).forEach((i) => e.set(He(i), "added")), e;
}
function He(o) {
  return j.fromSeconds(o).toISODate();
}
const Ve = "share-date-picker", ce = "absence", We = "absence-disabled", Ue = "sold";
function qe(o) {
  const t = j.now().startOf("day").toJSDate();
  return o.getTime() >= t.getTime() ? o : t;
}
function Je(o, t, e) {
  const a = j.now().startOf("day").toMillis(), n = o - a;
  return n < 0 ? !1 : typeof e != "number" || !t.find(
    (s) => j.fromISO(s.startDate).toMillis() === o
  ) ? !0 : n <= e;
}
function ir(o) {
  const t = M.useRef(null), e = M.useRef(/* @__PURE__ */ new Set()), a = M.useRef(
    o.daysSold.map((f) => j.fromISO(f).toMillis())
  ), [n, i] = M.useState(!1), s = M.useCallback((f) => {
    if (f.detail.view !== "Container")
      return;
    const k = f.target;
    a.current.forEach((m) => {
      const D = k.querySelector(
        `.day.unit[data-time="${m}"]`
      );
      D && D.classList.add(Ue);
    }), k.querySelectorAll(`.day.${ce}`).forEach((m) => {
      m.classList.remove(ce), m.classList.remove(We);
    }), e.current.forEach((m) => {
      const D = k.querySelector(
        `.day.unit[data-time="${m}"]`
      );
      D && (D.classList.add(ce), Je(m, o.absences, o.absenceRemoveLimit) || D.classList.add(We));
    });
  }, []);
  function c(f, k) {
    if (f < j.now().startOf("day").toJSDate().getTime())
      return;
    const D = k.querySelector(
      `.day.unit[data-time="${f}"]`
    );
    D && (D.classList.contains(Ue) || (e.current.has(f) ? Je(f, o.absences, o.absenceRemoveLimit) && e.current.delete(f) : e.current.add(f)));
  }
  const l = M.useCallback(
    (f) => {
      var k;
      f.target && (c(f.detail.date.getTime(), f.target), (k = t.current) == null || k.clear());
    },
    []
  );
  M.useEffect(() => {
    var D;
    e.current = new Set(
      o.absences.map((A) => j.fromISO(A.startDate).toMillis())
    );
    const f = document.getElementById(Ve);
    if (!f)
      return;
    const k = qe(o.reservation.startDate), m = {
      LockPlugin: {
        inseparable: !0,
        minDate: o.reservation.startDate,
        maxDate: o.reservation.endDate
      }
    };
    return t.current = new he.create({
      element: f,
      css: Zt,
      firstDay: 1,
      lang: o.lang,
      format: "YYYY-MM-DD",
      calendars: o.calendars,
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [fe],
      setup(A) {
        A.on("render", s), A.on("select", l);
      },
      ...m
    }), (D = t.current) == null || D.gotoDate(k), () => {
      t.current && (t.current.off("render", s), t.current.off("select", l), t.current.destroy(), t.current = null, e.current = /* @__PURE__ */ new Set());
    };
  }, []);
  async function g() {
    try {
      const f = Kt(o.absences, e.current);
      if (f.size === 0)
        return;
      i(!0), await o.saveSharingChanges(f);
    } finally {
      i(!1), o.onCloseDialog();
    }
  }
  function p() {
    var D;
    if (!t.current)
      return;
    const f = j.fromJSDate(o.reservation.endDate).endOf("day").toJSDate().getTime(), k = qe(o.reservation.startDate);
    let m = j.fromJSDate(k).startOf("day");
    for (let A = m.toJSDate().getTime(); A <= f; A = m.toJSDate().getTime())
      e.current.has(A) || c(A, t.current.ui.container), m = m.plus({ days: 1 }).startOf("day");
    (D = t.current) == null || D.clear();
  }
  function S() {
    var f;
    e.current.forEach((k) => {
      t.current && c(k, t.current.ui.container);
    }), (f = t.current) == null || f.clear();
  }
  return /* @__PURE__ */ v.jsxs("div", { className: "flex flex-auto flex-col lg:overflow-y-auto", children: [
    /* @__PURE__ */ v.jsxs("div", { className: "flex items-center justify-center gap-4 px-4 pt-4", children: [
      /* @__PURE__ */ v.jsx(
        ee,
        {
          onClick: p,
          variant: "outline",
          className: "hover:border-blue-500 hover:bg-blue-500",
          children: o.labels.selectAllBtn
        }
      ),
      /* @__PURE__ */ v.jsx(
        ee,
        {
          onClick: S,
          variant: "outline",
          className: "hover:border-blue-500 hover:bg-blue-500",
          children: o.labels.deselectAllBtn
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(Qe, { locale: o.lang }),
    /* @__PURE__ */ v.jsx("div", { className: "relative flex-auto text-center", children: /* @__PURE__ */ v.jsx("div", { className: "absolute inset-0 overflow-y-auto lg:static", children: /* @__PURE__ */ v.jsx("input", { id: Ve, type: "hidden" }) }) }),
    /* @__PURE__ */ v.jsx("div", { className: "relative bg-gray-50 p-4 text-center", children: /* @__PURE__ */ v.jsx(
      ee,
      {
        fullWidth: !0,
        type: "button",
        onClick: g,
        disabled: n,
        isLoading: n,
        children: o.labels.confirmBtn
      }
    ) })
  ] });
}
const Xt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars{padding:24px 0 16px}@media (max-width: 480px){.calendars{padding:8px 0}}.calendars .calendar:nth-child(n+2){display:none}@media (min-width: 992px){.calendars .calendar:nth-child(n+2){display:block}}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}.calendars.grid-2{grid-template-columns:none}@media (min-width: 992px){.calendars{padding:32px 16px 24px}.calendars.grid-2{grid-template-columns:repeat(2,1fr)}.calendars:not(.grid-1) .calendar>.header .next-button{visibility:hidden}}.calendar{padding:8px 24px}@media (max-width: 480px){.calendar{padding:8px}}.calendar>.header{position:relative;padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{position:absolute;top:5px;padding:0;border:none;border-radius:0}.calendar>.header button.previous-button{left:0}.calendar>.header button.next-button{right:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1);height:24px;width:auto}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.inline{min-height:unset}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}:host{--day-height: 40px;--day-width: 40px;--day-gap: 4px}.calendars{padding:0}.calendars .calendar>.days-grid>.day{width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width)}.calendars .calendar>.daynames-row>.dayname{width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width)}.calendar{padding:0}.calendar>.days-grid{gap:var(--day-gap);max-width:calc(var(--day-width) * 7 + var(--day-gap) * 6)}.calendar>.days-grid>.day.selected-day{background-color:var(--blue-500, #00B0FF);color:var(--white, #fff)}.calendar>.days-grid>.day.unavailable-day{color:var(--color-fg-locked, #9e9e9e);cursor:default;pointer-events:none;text-decoration:line-through}.calendar .daynames-row{max-width:calc(var(--day-width) * 7 + var(--day-gap) * 6);row-gap:var(--day-gap)}', Ge = "timeschedule-picker", ue = "selected-day", Ze = "unavailable-day";
function dr(o) {
  const t = M.useRef(null), e = M.useRef([]), a = M.useRef([]), n = M.useCallback(function(c) {
    if (c.detail.view !== "Container")
      return;
    const l = c.target;
    [ue, Ze].forEach((g) => {
      l.querySelectorAll(`.day.${g}`).forEach((p) => p.classList.remove(g));
    }), e.current.forEach((g) => {
      const p = l.querySelector(
        `.day.unit[data-time="${g}"]`
      );
      p && p.classList.add(ue);
    }), e.current.forEach((g) => {
      var p;
      (p = l.querySelector(`.day.unit[data-time="${g}"]`)) == null || p.classList.add(ue);
    }), a.current.forEach((g) => {
      var p;
      (p = l.querySelector(`.day.unit[data-time="${g}"]`)) == null || p.classList.add(Ze);
    });
  }, []), i = M.useCallback(
    (s) => {
      o.onDateSelect(s.detail.date.getTime());
    },
    [o.onDateSelect]
  );
  return M.useEffect(() => {
    var s;
    e.current = [...o.selectedDates], a.current = [...o.unavailableDays], (s = t.current) == null || s.clear();
  }, [o.selectedDates, o.unavailableDays]), M.useEffect(() => {
    var l;
    const s = document.getElementById(Ge);
    if (!s)
      return;
    const c = {
      LockPlugin: {
        minDate: o.minDate,
        maxDate: o.maxDate
      }
    };
    return t.current = new he.create({
      element: s,
      css: Xt,
      firstDay: 1,
      lang: o.lang,
      format: "YYYY-MM-DD",
      calendars: 1,
      // grid: 1,
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [fe],
      setup(g) {
        g.on("render", n), g.on("select", i);
      },
      ...c
    }), (l = t.current) == null || l.gotoDate(o.minDate), () => {
      t.current && (t.current.off("render", n), t.current.off("select", i), t.current.destroy(), t.current = null);
    };
  }, []), /* @__PURE__ */ v.jsx("div", { className: "flex flex-auto flex-col", children: /* @__PURE__ */ v.jsx("div", { className: "relative flex-auto text-center", children: /* @__PURE__ */ v.jsx("input", { id: Ge, type: "hidden" }) }) });
}
export {
  te as BookingHalfDay,
  B as BookingPeriod,
  or as DatePicker,
  Qe as DatePickerHeader,
  ir as SharingDatePicker,
  dr as TimeScheduleCalendar,
  Ot as getCalendarsByPeriod,
  Nt as isSameDay,
  zt as useDatePicker,
  $t as useFormattedPeriod
};
